import { type FC, type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../shared/auth/AuthContext';
import { getAdminLoginPath } from '../../shared/config/env';
import { getI18nStrings } from '../../shared/data/i18n';

interface ProtectedRouteProps {
  children: ReactElement;
}

/**
 * 認証が必要なルートを保護するコンポーネント
 */
const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const adminLoginPath = getAdminLoginPath();
  // admin画面は日本語のみを想定（将来的に多言語対応する場合はuseLanguageを使用）
  const i18n = getI18nStrings('ja');

  if (isLoading) {
    return <div>{i18n.common.loading}</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to={adminLoginPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
